import fusionConstant from './FusionConstant';
const PartnerLogo = require('./PartnerLogo');

const { flex } = window;
const { React } = flex.lib;

function CalvertFamily(props) {
    const { calvertFamilyOfCompanies: {
        header: header,
        itemList: family
    } } = fusionConstant;

    return (
        <div className='fusion-landing__calvert-family'>
            <div className='fusion-landing__calvert-family__header'>
                <span>{header}</span>
            </div>
            <PartnerLogo logoList={family} />
        </div>
    );
}

module.exports = CalvertFamily;
